import { Component, Optional } from '@angular/core';
import { Firestore, collection, collectionData } from '@angular/fire/firestore';
import {
  collaboratorsCategories,
  Collaborator,
  CollaboratorCategory
} from './collaborator.model';

@Component({
  selector: 'app-collaborators',
  standalone: false,
  templateUrl: './collaborators.component.html',
  styleUrls: [ './collaborators.component.scss' ]
})
export class CollaboratorsComponent {

  public collaborators: Collaborator[] = [];
  public collaboratorsCategories: CollaboratorCategory[] = collaboratorsCategories;

  constructor(@Optional() private firestore: Firestore | null) {
    if (!this.firestore) {
      return;
    }
    const collaboratorsCol = collection(this.firestore, 'collaborators');
    collectionData(collaboratorsCol).subscribe((collaborators) => {
      this.collaborators = collaborators as Collaborator[];
    });
  }
}
